export const GET_CONFIG = 'GET_CONFIG';
export const PROCESSING_GET_CONFIG = 'PROCESSING_GET_CONFIG';
export const GET_CONFIG_SUCCESS = 'GET_CONFIG_SUCCESS';
export const GET_CONFIG_FAILURE = 'GET_CONFIG_FAILURE';
export const CLEAR_ERROR_ON_GET_CONFIG = 'CLEAR_ERROR_ON_GET_CONFIG';

export const GET_CONFIG_DATA_MAP = 'GET_CONFIG_DATA_MAP';
export const GET_CONFIG_DATA_MAP_SUCCESS = 'GET_CONFIG_DATA_MAP_SUCCESS';
export const PROCESSING_GET_CONFIG_DATA_MAP = 'PROCESSING_GET_CONFIG_DATA_MAP';

export const UPDATE_CONFIG = 'UPDATE_CONFIG';
export const UPDATE_CONFIG_SUCCESS = 'UPDATE_CONFIG_SUCCESS';
export const CLEAN_UPDATE_CONFIG_SUCCESS = 'CLEAN_UPDATE_CONFIG_SUCCESS';
export const UPDATE_CONFIG_FAILURE = 'UPDATE_CONFIG_FAILURE';
export const CLEAR_ERROR_ON_UPDATE_CONFIG = 'CLEAR_ERROR_ON_UPDATE_CONFIG';

export const PROCESSING_UPDATE_CONFIG = 'PROCESSING_UPDATE_CONFIG';

export const CLEAN_ALL_ERRORS = 'CLEAN_ALL_ERRORS';

export const DELETE_CONFIG_KEY = 'DELETE_CONFIG_KEY';
export const PROCESSING_DELETE_CONFIG_KEY = 'PROCESSING_DELETE_CONFIG_KEY';
export const DELETE_CONFIG_FAILURE = 'DELETE_CONFIG_FAILURE';

export const CLEAN_FINISHED_CONTAINERS = 'CLEAN_FINISHED_CONTAINERS';
export const CLEAN_FINISHED_CONTAINERS_SUCCESS = 'CLEAN_FINISHED_CONTAINERS_SUCCESS';
export const CLEAN_FINISHED_CONTAINERS_FAILURE = 'CLEAN_FINISHED_CONTAINERS_FAILURE';
